// extracted by mini-css-extract-plugin
export default {"subtext":"IntroHeader_subtext__uZBTU","name":"IntroHeader_name__nekcM","lastname":"IntroHeader_lastname__MB3xl","overlay":"IntroHeader_overlay__wfeLN"};